"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configDefaults = void 0;
var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var configDefaults = exports.configDefaults = {
  nui: {
    session: {
      use_performance_degrading_session_logging: {
        value: true,
        useDefault: true
      }
    },
    use_16_cols: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    layout_fully_responsive: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    layout_fluid: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    geoip_url: {
      value: 'http://concur-geoip.nui.svc.cluster.local:3000/geoip',
      useDefault: true
    },
    default_brandingId: {
      value: 16,
      useDefault: true,
      clientExposed: true
    },
    use_anonymous_error_routes: {
      value: false,
      clientExposed: true,
      useDefault: true
    },
    content_density: {
      value: 'cozy',
      clientExposed: true,
      useDefault: true
    },
    assets: {
      shared: {
        dev: {
          value: false,
          clientExposed: true,
          useDefault: true
        }
      },
      app: {
        path: {
          value: '/static',
          clientExposed: true,
          useDefault: true
        },
        useCDN: {
          value: false,
          clientExposed: true,
          useDefault: true
        }
      },
      cdn: {
        path: {
          value: '',
          clientExposed: true,
          useDefault: true
        },
        url: {
          value: '//static.concursolutions.com',
          clientExposed: true,
          useDefault: true
        }
      }
    },
    apigateway: {
      browser: {
        url: {
          clientExposed: true,
          value: 'https://www-rqa3.api.nonprod.cnqr.tech'
        }
      },
      server: {
        url: {
          clientExposed: false,
          value: 'http://rqa3.api.nonprod.cnqr.tech:443'
        }
      }
    },
    analytics: {
      useDefault: true,
      clientExposed: true,
      value: {
        forceSinglePing: false,
        enabled: false
      }
    },
    csp: {
      reportOnly: {
        value: false,
        useDefault: true,
        clientExposed: true
      },
      enforced: {
        value: false,
        useDefault: true,
        clientExposed: true
      }
    },
    processListeners: {
      useDefault: true,
      clientExposed: false,
      value: {
        disabled: false
      }
    }
  },
  nrb: {
    clientExposed: true,
    accountId: {
      useDefault: true,
      value: ''
    },
    agentId: {
      useDefault: true,
      value: ''
    },
    agentLoc: {
      useDefault: true,
      value: 'static.concursolutions.com/newrelic'
    },
    agentType: {
      useDefault: true,
      value: 'pro'
    },
    agentVer: {
      useDefault: true,
      value: '1198'
    },
    allowedOrigins: {
      useDefault: true,
      value: ''
    },
    appId: {
      useDefault: true,
      value: ''
    },
    beacon: {
      useDefault: true,
      value: 'eum.concursolutions.com'
    },
    cookiesEnabled: {
      useDefault: true,
      value: true
    },
    corsNewrelicHeader: {
      useDefault: true,
      value: false
    },
    corsTraceContextHeaders: {
      useDefault: true,
      value: false
    },
    distributedTracing: {
      useDefault: true,
      value: true
    },
    errBeacon: {
      useDefault: true,
      value: 'eum.concursolutions.com'
    },
    integrityHash: {
      useDefault: true,
      value: ''
    },
    licenseKey: {
      useDefault: true,
      value: ''
    },
    trustKey: {
      useDefault: true,
      value: ''
    }
  },
  is_gov: {
    value: false,
    useDefault: true,
    clientExposed: true
  },
  crossPlatformDelivery: {
    baseUrl: {
      value: 'https://static.concursolutions.com',
      useDefault: true,
      clientExposed: true
    },
    url: {
      value: '/cross-platform-delivery/manifest-dev.json',
      clientExposed: true
    },
    env: {
      value: 'fallback',
      useDefault: true,
      clientExposed: true
    },
    isEnabled: {
      value: true,
      useDefault: true,
      clientExposed: true
    },
    timeoutMs: {
      value: 5000,
      useDefault: true,
      clientExposed: true
    },
    isCacheEnabled: {
      value: true,
      useDefault: true,
      clientExposed: true
    }
  }
};
var _default = exports.default = (0, _nuiConfig.default)(configDefaults);